import React, { useState, useEffect } from "react";
import Layout from "../components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { generateMail } from "../features/mail/mailSlice";
import { toast } from "react-toastify";
import GenerateMail from "../components/GenerateMail/GenerateMail";

const HomeScreen = () => {
  const [inputData, setInputData] = useState("Click generate to start");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, isError, message } = useSelector((state) => state.auth);
  const { generatedmail } = useSelector((state) => state.mail);

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }

    if (isError) {
      toast.error(message);
    }

    if (generatedmail) {
      let randomstr = (Math.random() + 1).toString(36).substring(7);
      const test = generatedmail.generatedmail;
      const name = test.substring(0, test.lastIndexOf("@"));
      const domain = test.substring(test.lastIndexOf("@") + 1);
      const generatedInput = `${name}+${randomstr}@${domain}`;
      // console.log(generatedInput);
      setInputData(generatedInput);
    }
  }, [user, navigate, isError, message, generatedmail]);

  const onClickHandler = () => {
    dispatch(generateMail());
    console.log("Generate");
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();

    if (generatedmail !== null) {
      navigate(`/inbox/${inputData}`);
    }
  };

  return (
    <Layout>
      <GenerateMail
        text={inputData}
        onClickHandle={onClickHandler}
        onSubmitHandle={onSubmitHandler}
      />
    </Layout>
  );
};

export default HomeScreen;
